import { render } from "./OrderLimitPopover.vue?vue&type=template&id=775bab72&ts=true"
import script from "./OrderLimitPopover.vue?vue&type=script&lang=ts"
export * from "./OrderLimitPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__